import { useNavigate, useParams, useSearch } from '@tanstack/react-router';
import { ReviewScreen, ocrPreviewStore, type ReviewItem } from '@mrrmlab/feature-shopping-list';
import type { ParsedItem } from '@mrrmlab/api-client';

export function ListReviewRoute() {
  const { listId } = useParams({ from: '/lists/$listId/review' });
  const { items: itemsParam } = useSearch({ from: '/lists/$listId/review' });
  const navigate = useNavigate();

  let initialItems: ReviewItem[] = [];
  try {
    const parsed = JSON.parse(itemsParam ?? '[]') as ParsedItem[];
    initialItems = parsed.map((i) => ({ name: i.name, suggestions: i.suggestions }));
  } catch {
    initialItems = [];
  }

  const previewImage = ocrPreviewStore.consume();
  const back = () => void navigate({ to: '/lists/$listId', params: { listId } });

  return (
    <ReviewScreen
      listId={listId}
      initialItems={initialItems}
      previewImage={previewImage}
      onBack={back}
      onImported={back}
    />
  );
}
